import { render, staticRenderFns } from "./productHeader.vue?vue&type=template&id=f70b55d8&scoped=true&"
import script from "./productHeader.vue?vue&type=script&lang=js&"
export * from "./productHeader.vue?vue&type=script&lang=js&"
import style0 from "./productHeader.vue?vue&type=style&index=0&id=f70b55d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f70b55d8",
  null
  
)

export default component.exports